import { createSwitchController } from '@atlassian/jira-switch-controller/src/index.tsx';

const { useSwitch } = createSwitchController<string>('spotlight');

export const useFromSpotlightTour = useSwitch;

export type UseFromSpotlightTourType = typeof useSwitch;
